<template>
  <div>
    <v-card class="pa-2 bordered">
      <v-form ref="login_form">
        <label class="field_label">Identifiant</label>
        <v-text-field class="my-1" v-model="admin.username" :rules="[$formRules.required]"></v-text-field>
        <label class="field_label">Mot de passe</label>
        <v-text-field v-model="admin.pass" :rules="[$formRules.required]" :type="showpass ? 'text' : 'password'"
          :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showpass = !showpass"></v-text-field>

        <v-alert color="dark-red" variant="tonal" density="compact" class="mb-2" v-if="error" type="error">{{ error
          }}</v-alert>
        <v-btn color="primary-dark" variant="tonal" size="large" class="mb-3" block
          @click="handleRegister">Enregistrer</v-btn>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service";
export default {
  data() {
    return {
      showpass: false,
      error: "",
      admin: {
        username: "",
        pass: "",
        id_module: null,
      },
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async handleRegister() {
      const { valid } = await this.$refs.login_form.validate();
      if (valid) {
        let request = await AdminService.registerAuthorizedUser(this.admin);
        if (!request.error) {
          this.error = "";
          this.admin = {
            username: "",
            pass: "",
            id_module: this.mainStore.module.id
          };
          this.$emit("success");
        } else {
          this.error = request.error;
        }
      }
    },
  },
  mounted() {
    this.admin.id_module = this.mainStore.module.id;
  }
};
</script>

<style lang="scss" scoped></style>